export const LOADING_NOTIFICATION_BODY = "LOADING_NOTIFICATION_BODY";
export const SAVE_LOADING_NOTIFICATION_BODY = "SAVE_LOADING_NOTIFICATION_BODY";
export const GET_NOTIFICATION_BODY = "GET_NOTIFICATION_BODY";
export const FORM_FAIL = "FORM_FAIL";
export const NOTIFICATION_BODY_FAIL = "NOTIFICATION_BODY_FAIL";
export const LOADING_NOTIFICATION_BODY_BY_ID = "LOADING_NOTIFICATION_BODY_BY_ID";
export const GET_NOTIFICATION_BODY_BY_ID = "GET_NOTIFICATION_BODY_BY_ID";